var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 47,
    viewBox: "0 0 48 47",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.300781,
    x2: 47.2032,
    y1: 23.3681,
    y2: 23.3681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m38.3902-.00878906c2.1065 0 4.1844.72829706 5.7607 2.12776906 2.0349 1.79932 3.0523 4.01277 3.0523 6.64036v29.21756c0 2.8561-1.1894 5.2123-3.5825 7.083-1.476 1.1568-3.3389 1.6851-5.2019 1.6851h-29.31934c-2.63674 0-4.85789-1.0139-6.66349-3.0417-1.40435-1.5851-2.135189-3.6415-2.135189-5.755v-29.18896c0-2.62759 1.017449-4.84104 3.052319-6.64036 1.59064-1.399472 3.65417-2.12776906 5.77503-2.12776906zm-1.7204 12.55208906c1.4187.3713 2.5221 1.4852 2.909 2.899.7022 2.5704.6735 7.9398.6735 7.9398s0 5.3409-.6735 7.9113c-.3726 1.4138-1.4903 2.5134-2.909 2.8989-2.5794.6712-12.9114.6712-12.9114.6712s-10.3033 0-12.9114-.6997c-1.4187-.3713-2.52212-1.4852-2.90903-2.8989-.67351-2.5419-.67352-7.9113-.67352-7.9113s.00001-5.3409.67352-7.9113c.37258-1.4138 1.51899-2.5419 2.90903-2.9275 2.5794-.6712 12.9114-.6712 12.9114-.6712s10.332 0 12.9114.6997zm-7.0361 10.796-9.7588-5.5979v11.1958z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c41fa612ec348e8860339fa7562329a2.svg";
export { ForwardRef as ReactComponent };